import Footer from "../../components/footer/Footer";
import Form from "../../components/Form/Form";
import TrueFooter from "../../components/TrueFooter/TrueFooter";
import styles from "./About.module.scss";
import { useRef, useEffect, useState } from "react";
import LocomotiveScroll from "locomotive-scroll";
import { useScroll, motion, useTransform, color } from "framer-motion";
import TitleSection from "../../components/aboutPage/TitleSection/TitleSection";
import ValueSection from "../../components/aboutPage/ValuesSection/ValuesSection";
import BackgroundAnimation from "../../components/aboutPage/BackgroundAnimation/BackgroundAnimation";
import TeamCarousel from "../../components/aboutPage/TeamCarousel/TeamCarousel";
import useDeviceDetection from "../../hooks/useDeviceDetection";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  selectCustomizedSolutionsBlocks,
  selectInviteBlocks,
  selectLearnMoreBlocks,
  selectLearnMoreBlocksMedia,
  selectOurTeamBlocks,
  selectOurTeamBlocksMedia,
} from "../../store/selectors/content/aboutPageSelectors";
import {
  fetchCustomizedSolutionsBlocks,
  fetchInviteBlocks,
  fetchLearnMoreBlocks,
  fetchLearnMoreBlocksMedia,
  fetchOurTeamBlocks,
  fetchOurTeamBlocksMedia,
} from "../../store/api/content/aboutPageApi";

const startPosition = 0;
const firstSlideTopStart = startPosition;
const firstSlideTopEnd = firstSlideTopStart + 0.2;

const secondSlideTopStart = firstSlideTopStart + 0.1;
const secondSlideTopEnd = secondSlideTopStart + 0.2;
const thirdSlideTopStart = secondSlideTopEnd;
const thirdSlideTopEnd = thirdSlideTopStart + 0.01;
const fourthSlideTopStart = thirdSlideTopEnd;
const fourthSlideTopEnd = fourthSlideTopStart + 0.1;
const fifthSlideTopStart = fourthSlideTopEnd;
const fifthSlideTopEnd = fifthSlideTopStart + 0.1;
const sixSlideTopStart = fifthSlideTopEnd;
const sixSlideTopEnd = sixSlideTopStart + 0.1;
const formSlideTopStart = sixSlideTopEnd;
const formSlideTopEnd = formSlideTopStart + 0.1;
const footerSlideTopStart = formSlideTopEnd;
const footerSlideTopEnd = footerSlideTopStart + 0.1;

const firstWorthAppearStart = secondSlideTopStart + 0.04;
const firstWorthAppearEnd = firstWorthAppearStart + 0.04;
const secondWorthAppearStart = firstWorthAppearEnd;
const secondWorthAppearEnd = secondWorthAppearStart + 0.03;
const thirdWorthAppearStart = secondWorthAppearEnd;
const thirdWorthAppearEnd = thirdWorthAppearStart + 0.03;
const fourthWorthAppearStart = thirdWorthAppearEnd;
const fourthWorthAppearEnd = fourthWorthAppearStart + 0.03;
const fifthWorthAppearStart = fourthWorthAppearEnd;
const fifthWorthAppearEnd = fifthWorthAppearStart + 0.03;


const MobilefirstWorthAppearStart = secondSlideTopStart;
const MobilefirstWorthAppearEnd = MobilefirstWorthAppearStart + 0.03;
const MobilesecondWorthAppearStart = MobilefirstWorthAppearEnd;
const MobilesecondWorthAppearEnd = MobilesecondWorthAppearStart + 0.03;
const MobilethirdWorthAppearStart = MobilesecondWorthAppearEnd;
const MobilethirdWorthAppearEnd = MobilethirdWorthAppearStart + 0.04;
const MobilefourthWorthAppearStart = MobilethirdWorthAppearEnd;
const MobilefourthWorthAppearEnd = MobilefourthWorthAppearStart + 0.03;
const MobilefifthWorthAppearStart = MobilefourthWorthAppearEnd;
const MobilefifthWorthAppearEnd = MobilefifthWorthAppearStart + 0.03;

const About = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const device = useDeviceDetection();
  const { scrollYProgress } = useScroll();
  const [scrollInstance, setScrollInstance] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false); // Контроль состояния меню
  const [isRtl, setIsRtl] = useState(false); // Состояние для проверки языка
  useEffect(() => {
    const language = localStorage.getItem("language"); // или ваш ключ
    setIsRtl(language === "heb"); // true, если иврит
  }, []);

  const ourLanguage = localStorage.getItem("language") === "heb" ? "he" : "en";
  const dispatch = useDispatch();

  useEffect(() => {
    const scroll = new LocomotiveScroll({
      el: scrollRef.current,
      smooth: true,
      smoothMobile: true,
      inertia: 0.8,
    });
    setScrollInstance(scroll);
    window.scrollTo(0, 0);
    scrollYProgress.onChange((latest) => {
      const scrollPercentage = latest * 100; // Преобразуем в проценты
      // console.log(`Page scrolled: ${scrollPercentage}%`);
    });
    return () => {
      if (scroll) scroll.destroy();
    };
  }, [scrollYProgress]);
  useEffect(() => {
    if (scrollInstance) {
      if (isMenuOpen) {
        scrollInstance.stop(); // Останавливаем скролл при открытом меню
      } else {
        scrollInstance.start(); // Включаем скролл при закрытом меню
      }
    }
  }, [isMenuOpen, scrollInstance]);

  const transforms = {
    first: useTransform(
      scrollYProgress,
      [firstSlideTopStart, firstSlideTopEnd],
      device === "Mobile" ? ["0vw", "-540vw"] : ["0vh", "-265vh"]
    ),
    second: useTransform(
      scrollYProgress,
      device === "Mobile"
        ? [
            secondSlideTopStart - 0.02,
            secondSlideTopEnd,
            thirdSlideTopStart,
            thirdSlideTopEnd,
          ]
        : [
            secondSlideTopStart+0.02,
            secondSlideTopEnd,
            thirdSlideTopStart,
            thirdSlideTopEnd,
          ],
      device === "Mobile"
        ? ["270vw", "-400vw", "-400vw", "-620vw"]
        : ["100vh", "-170vh", "-170vh", "-170vh"]
    ),
    third: useTransform(
      scrollYProgress,
      device === "Mobile"
        ? [
            thirdSlideTopStart - 0.06,
            thirdSlideTopEnd - 0.02,
            fourthSlideTopStart - 0.05,
            fifthSlideTopEnd - 0.05,
          ]
        : [
            thirdSlideTopStart - 0.01,
            thirdSlideTopEnd + 0.05,
            fourthSlideTopStart,
            fifthSlideTopEnd,
          ],
      device === "Mobile"
        ? ["100vh", "0vh", "0vh", "-20vh"]
        : ["100vh", "0vh", "0vh", "-20vh"]
    ),
    fourth: useTransform(
      scrollYProgress,
      device === "Mobile"
        ? [
            fourthSlideTopStart - 0.05,
            fourthSlideTopEnd,
            fifthSlideTopStart,
            fifthSlideTopEnd,
          ]
        : [
            fourthSlideTopStart,
            fourthSlideTopEnd + 0.1,
            fifthSlideTopStart+0.1,
            fifthSlideTopEnd+0.1,
          ],
      ["100vh", "-60vh", "-60vh", "-170vh"]
    ),
    fifth: useTransform(
      scrollYProgress,
      device === "Mobile"
        ? [fourthSlideTopStart - 0.05, fifthSlideTopEnd - 0.02]
        : [fourthSlideTopStart, fifthSlideTopEnd+0.09],
      device === "Mobile" ? ["300vw", "0vw"] : ["100vh", "0vh"]
    ),
    six: useTransform(
      scrollYProgress,
      device === 'Mobile'
      ?[
        sixSlideTopStart,
        sixSlideTopEnd,
        formSlideTopStart,
        formSlideTopEnd-0.03,
        footerSlideTopStart+0.1,
        footerSlideTopEnd+0.1,
      ]
      :[
        sixSlideTopStart+0.14,
        sixSlideTopEnd+0.14,
        formSlideTopStart+0.14,
        formSlideTopEnd+0.1,
        footerSlideTopStart+0.1,
        footerSlideTopEnd+0.1,
      ],
      device === 'Mobile' ? ["100vh", "0vh", "0vh", "-75vh", "-65vh", "-65vh"]
      :
      ["100vh", "0vh", "0vh", "-50vh", "-50vh", "-100vh"]
    ),
    backgroundOpacity: useTransform(
      scrollYProgress,
      device === "Mobile"
        ? [secondSlideTopStart - 0.1, secondSlideTopStart]
        : [secondSlideTopStart, secondSlideTopStart + 0.02],
      [1, 0]
    ),
    firstWorth: useTransform(
      scrollYProgress,
      device === "Mobile"
        ? [MobilefirstWorthAppearStart, MobilefirstWorthAppearEnd]
        : [firstWorthAppearStart, firstWorthAppearEnd],
      [0, 1]
    ),
    secondWorth: useTransform(
      scrollYProgress,
      device === "Mobile"
        ? [MobilesecondWorthAppearStart, MobilesecondWorthAppearEnd]
        : [secondWorthAppearStart, secondWorthAppearEnd],
      [0, 1]
    ),
    thirdWorth: useTransform(
      scrollYProgress,
      device === "Mobile"
        ? [MobilethirdWorthAppearStart, MobilethirdWorthAppearEnd]
        : [thirdWorthAppearStart, thirdWorthAppearEnd],
      [0, 1]
    ),
    fourthWorth: useTransform(
      scrollYProgress,
      device === "Mobile"
        ? [MobilefourthWorthAppearStart, MobilefourthWorthAppearEnd]
        : [fourthWorthAppearStart, fourthWorthAppearEnd],
      [0, 1]
    ),
    fifthWorth: useTransform(
      scrollYProgress,
      device === "Mobile"
        ? [MobilefifthWorthAppearStart, MobilefifthWorthAppearEnd]
        : [fifthWorthAppearStart, fifthWorthAppearEnd],
      [0, 1]
    ),
    form: useTransform(
      scrollYProgress,
      device === "Mobile"
        ? [
            formSlideTopStart-0.04,
            formSlideTopEnd - 0.04,
            footerSlideTopStart,
            footerSlideTopEnd,
          ]
        : [
            formSlideTopStart+0.1 ,
            formSlideTopEnd+0.1,
            footerSlideTopStart+0.1,
            footerSlideTopEnd+0.1,
          ],
      device === "Mobile"
        ? ["100vh", "0vh", "0vh", "-30vh"]
        : ["100vh", "13vh", "13vh", "-45vh"]
    ),
    trueFooter: useTransform(
      scrollYProgress,
      device === "Mobile"
        ? [footerSlideTopStart, footerSlideTopEnd - 0.03]
        : [footerSlideTopStart+0.08 , footerSlideTopEnd+0.12],
      device === "Mobile" ? ["100vh", "58vh"] : ["100vh", "50vh"]
    ),
  };
  const handleClickAllProducts = () => {
    navigate("/products");
  };
  const customizedSolutionsBlocks = useSelector((state) =>
    selectCustomizedSolutionsBlocks(state, ourLanguage)
  );

  const ourTeamBlocks = useSelector((state) =>
    selectOurTeamBlocks(state, ourLanguage)
  );

  const ourTeamBlocksMedia = useSelector((state) =>
    selectOurTeamBlocksMedia(state)
  );

  const learnMoreBlocks = useSelector((state) =>
    selectLearnMoreBlocks(state, ourLanguage)
  );

  const learnMoreBlocksMedia = useSelector((state) =>
    selectLearnMoreBlocksMedia(state)
  );

  const inviteBlocks = useSelector((state) =>
    selectInviteBlocks(state, ourLanguage)
  );

  useEffect(() => {
    if (!customizedSolutionsBlocks) {
      dispatch(fetchCustomizedSolutionsBlocks(ourLanguage));
    }
  }, [dispatch, ourLanguage, customizedSolutionsBlocks]);

  useEffect(() => {
    if (!ourTeamBlocks) {
      dispatch(fetchOurTeamBlocks(ourLanguage));
    }
  }, [dispatch, ourLanguage, ourTeamBlocks]);

  useEffect(() => {
    if (!ourTeamBlocksMedia) {
      dispatch(fetchOurTeamBlocksMedia());
    }
  }, [dispatch, ourTeamBlocksMedia]);

  useEffect(() => {
    if (!learnMoreBlocks) {
      dispatch(fetchLearnMoreBlocks(ourLanguage));
    }
  }, [dispatch, ourLanguage, learnMoreBlocks]);

  useEffect(() => {
    if (!learnMoreBlocksMedia) {
      dispatch(fetchLearnMoreBlocksMedia());
    }
  }, [dispatch, learnMoreBlocksMedia]);

  useEffect(() => {
    if (!inviteBlocks) {
      dispatch(fetchInviteBlocks(ourLanguage));
    }
  }, [dispatch, ourLanguage, inviteBlocks]);

  return (
    <div className={`${styles.bigContainer} ${isRtl ? styles.hebFont : styles.enFont}`} data-scroll-container ref={scrollRef}>
      <div className={styles.stickyBlock} data-scroll-section>
        <motion.div className={styles.mainAbout}>
          <TitleSection ourLanguage={ourLanguage} top={transforms.first} />
          <ValueSection
            ourLanguage={ourLanguage}
            top={transforms.second}
            opacity1={transforms.firstWorth}
            opacity2={transforms.secondWorth}
            opacity3={transforms.thirdWorth}
            opacity4={transforms.fourthWorth}
            opacity5={transforms.fifthWorth}
          />
          <BackgroundAnimation
            backgroundOpacity={transforms.backgroundOpacity}
          />
          <motion.div
            className={styles.writtenAboutUs}
            style={{ top: transforms.third,gap: isRtl ? "8vw" : undefined, }}
          >
            {device === "Mobile" ? (
              <>
                <div className={`${styles.blockName} ${ isRtl ? styles.hebFont : styles.enFont}`} style={{color:'#f77f1e',fontSize:'1.2rem',fontWeight:'700',textTransform:'uppercase'}}>
                  {t("Customized_solutions")}
                </div>
                <div>
                  <div
                    className={styles.blockTitle}
                    style={{
                      fontSize: isRtl ? "36px" : "42px",
                      whiteSpace: "pre-line",
                    }}
                  >
                    {customizedSolutionsBlocks?.title
                      ?.split(/\/color\/(.*?)\/color\//g)
                      .map((part, index) => (
                        index % 2 === 1 
                          ? <span key={index} className={styles.orange}>{part}</span> 
                          : part
                      ))}
                  </div>
                  <div
                    style={{ whiteSpace: "pre-line" }}
                    className={`${styles.blockNameMobile} ${ isRtl ? styles.hebFont : styles.enFont}`}
                  >
                    {customizedSolutionsBlocks &&
                      customizedSolutionsBlocks?.description}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className={styles.blockName} style={{color:'#f77f1e',fontSize:'1.2rem',fontWeight:'700',textTransform:'uppercase'}}>
                  {t("Customized_solutions")}
                </div>
                <div>
                  <div
                    style={{ whiteSpace: "pre-line" }}
                    className={styles.blockTitle}
                  >
                    {customizedSolutionsBlocks?.title
                      ?.split(/\/color\/(.*?)\/color\//g)
                      .map((part, index) => (
                        index % 2 === 1 
                          ? <span key={index} className={styles.orange}>{part}</span> 
                          : part
                      ))}
                  </div>
                  <div
                    style={{ whiteSpace: "pre-line" }}
                    className={styles.blockName}
                  >
                    {customizedSolutionsBlocks &&
                      customizedSolutionsBlocks?.description}
                  </div>
                </div>
              </>
            )}

            <div
              className={styles.bgImage}
              style={{
              left: isRtl ? "0" : "auto",
              right: isRtl ? "auto" : "0",
              opacity: '0.4',
              aspectRatio: '1 / 1',
            }}
            >
              <img src="/images/aboutWrittenAboutUs.svg" alt="no-image" />
            </div>
          </motion.div>
          <motion.div
            className={`${styles.ourTeam} ${isRtl ? styles.hebFont : styles.enFont}`}
            style={{ top: transforms.fourth,gap: isRtl ? "14vw" : undefined }}
          >
            <div
              className={`${styles.blockName} ${ isRtl? styles.hebFont : styles.enFont}`}
              style={{ marginRight: isRtl ? "25px" : "0" ,color:'#f77f1e',fontSize:'1.2rem',fontWeight:'700'}}
            >
              {t("OUR_TEAM")}
            </div>
            <div>
              <div
                style={{ whiteSpace: "pre-line" }}
                className={`${styles.blockTitle} ${isRtl ? styles.hebFont : styles.enFont}`}
              >
                {ourTeamBlocks?.Title?.title?.split(/\/color\/(.*?)\/color\//g).map((part, index) => (
                  index % 2 === 1 ? <span key={index} className={styles.orange}>{part}</span> : part
                ))}
              </div>
              {ourTeamBlocks &&
                ourTeamBlocks?.Cards &&
                ourTeamBlocksMedia &&
                ourTeamBlocksMedia?.Cards && (
                  <TeamCarousel
                    content={ourTeamBlocks?.Cards}
                    media={ourTeamBlocksMedia?.Cards}
                  />
                )}
            </div>
          </motion.div>
          <motion.div
            className={`${styles.learnMore} ${ isRtl ? styles.hebFont : styles.enFont}`}
            style={{
              top: transforms.fifth,
              backgroundColor: isRtl ? "#d3dfdb" : "#dbe3e6",
            }}
          >
            <div className={styles.textContainer}>
              <div
                style={{ whiteSpace: "pre-line" }}
                className={styles.textTitle}
              >
                {learnMoreBlocks &&
                  learnMoreBlocks?.title
                    ?.split(/\/color\/(.*?)\/color\//g)
                    .map((part, index) => {
                      if (index % 2 === 1) {
                        return (
                          <span
                            key={`${index} TitleSection-title`}
                            className={styles.orange}
                          >
                            {part}
                          </span>
                        ); // Если это часть с маркером /color/
                      }
                      return part;
                    })}
              </div>
              <div
                style={{ whiteSpace: "pre-line" }}
                className={`${styles.textContent} ${isRtl ? styles.hebFont : styles.enFont}`}
              >
                {learnMoreBlocks?.description
                  ? learnMoreBlocks.description
                      .split(/\/color\/(.*?)\/color\//g)
                      .map((part, index) => {
                        // Каждый нечетный индекс — это текст, который был внутри /color/.../color/
                        if (index % 2 === 1) {
                          return (
                            <span
                              key={`${index}-learnMore-highlight`}
                              className={styles.orange}
                            >
                              {part}
                            </span>
                          );
                        }
                        // Обычный текст
                        return part;
                      })
                  : null}
                <br />
              </div>
              <div className={`${styles.button} ${isRtl ? styles.hebFont : styles.enFont}`} onClick={handleClickAllProducts}>
                <span className={styles.buttonText}>
                  {learnMoreBlocks && learnMoreBlocks?.buttonText}
                </span>
              </div>
            </div>
            <div
              className={styles.bgImage}
              style={{ left: device === "Mobile" && isRtl ? "0vw" : ""}}
            >
              <img
                style={{
                  left:
                    device === "Mobile"
                      ? isRtl
                        ? "-188px"
                        : "0"
                      : isRtl
                      ? "0vw"
                      : "50%"
                }}
                src="/images/aboutLearnMoreBG.jpg"
                alt="no-image"
              />
            </div>
          </motion.div>
        </motion.div>
        <motion.div className={styles.weInvite} style={{ top: transforms.six }}>
          <div className={styles.textBlock}>
            <div
              style={{ whiteSpace: "pre-line" }}
              className={styles.textTitle}
            >
              {inviteBlocks?.title
                ? inviteBlocks.title
                    .split(/\/color\/(.*?)\/color\//g)
                    .map((part, index) => {
                      if (index % 2 === 1) {
                        return (
                          <span key={`${index}-invite-title-color`} className={styles.orange}>
                            {part}
                          </span>
                        );
                      }
                      return part;
                    })
                : null}
            </div>
            <div
              style={{ whiteSpace: "pre-line" }}
              className={`${styles.textContent} ${isRtl ? styles.hebFont : styles.enFont}`}
            >
              {inviteBlocks?.description
                ? inviteBlocks.description
                    .split(/[\/\\].*?color[\/\\].*?(.*?)[\/\\].*?color[\/\\].*?/gs)
                    .map((part, index) => {
                      if (!part || part.trim() === "") return null;
                      
                      if (index % 2 === 1) {
                        return (
                          <span key={`${index}-invite-desc-color`} className={styles.orange}>
                            {part}
                          </span>
                        );
                      }
                      return part;
                    })
                : null}
            </div>
          </div>
        </motion.div>
        <Form top={transforms.form} />
        <TrueFooter top={transforms.trueFooter} />
      </div>
      <Footer isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
    </div>
  );
};

export default About;
